export default __webpack_public_path__ + "static/media/honey_homage.3123a99f.jpg";